import { useTranslation } from "react-i18next";

interface Props {
  roomName: string;
}

const RoomName = ({ roomName }: Props) => {
  const { t } = useTranslation();

  return <span className="text-xl font-bold">{`${t("room")} ${roomName}`}</span>;
};

export default RoomName;
